import React from 'react';
import { BrowserRouter} from "react-router-dom";
import './App.scss';
import Header from 'src/components/Header';
import Footer from 'src/components/Footer';
import NavPane from 'src/components/NavPane';
import Router from 'src/components/Router';

function App() {
    return <div className="app">
         <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Header></Header>
            <div className="main-layout">
                    <nav className="nav-sidepanel">
                        <NavPane />
                    </nav>
                    <div className="main-content">
                        <Router />
                    </div>
            </div>
            <Footer></Footer>
        </BrowserRouter>
    </div>;
}


export default App;
